import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTab, MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, take } from 'rxjs';
import { MatDialogComponent } from 'src/app/mat-dialog/mat-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { Approvalstatus, Client, DealerMediaResponse, EndApproval, FileLinkWithThumbnail, GetDetailsResponse, JobStatus, ServiceJob, StyleSettingsDealerImage } from 'src/app/services/client.service';
import { CarouselComponent } from "../../../carousel/carousel.component";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconModule, ButtonModule, TilesModule, StructuredListModule } from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MediaCarouselComponent } from 'src/app/media-carousel/media-carousel.component';
import { TickSnackbarComponent } from 'src/app/tick-snackbar/tick-snackbar.component';

@Component({
  selector: 'app-vhc-jobs-auth',
  templateUrl: './vhc-jobs-auth.component.html',
  styleUrls: ['./vhc-jobs-auth.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    CommonModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatMenuModule,
    MediaCarouselComponent
  ],
})
export class VhcJobsAuthComponent implements OnInit {
  noPendingRequest: string = $localize`No pending requests`;
  pendingDescription: string = $localize`There are no pending requests for your vehicle.`;
  noCriticalFindings: string = $localize`No critical findings`;
  criticalDescription: string = $localize`There are no critical findings in your vehicle.`;
  noCautionaryFindings: string = $localize`No cautionary findings`;
  cautionaryDescription: string = $localize`There are no cautionary findings in your vehicle.`;
  noCheckedFindings: string = $localize`No checked and ok findings`;
  checkedDescription: string = $localize`There are no checked and ok findings in your vehicle.`;
  noFindingsAvailable: string = $localize`No findings available`;
  noFindingsDescription: string = $localize`There are no findings recorded for your vehicle at the moment.`;
  pendingRequestsLabel = $localize`:@@pendingRequests:Pending Requests`;
  partsLabel = $localize`:@@parts:Parts`;
  labourLabel = $localize`:@@labour:Labours`;
  glAccount = $localize`:@@glAccount:G/L Account`;
  ExServices = $localize`:@@Ex.Services:External Service`;
  authorizationSent: string = $localize`Authorization sent`;

  @Input() apiResponse: any;
  @Output() updateChecklistData = new EventEmitter<void>();
  response: any = null;
  checkpointJobs: any = [];
  checkpointJobsCategoryWise: any = [];
  details: any;
  findingsJobs: any = [];
  findingsJobsCategoryWise: any = [];
  filteredFindingsJobs: any;
  selectedTab: string = 'pending';
  selectedCategory: string = 'All';
  selectedTabIndex: number = 0;
  allCheckpointJobs: any[] = [];
  allFindingsJobs: any[] = [];
  token: string = '';
  serviceJobs: any = [];
  bodyData: EndApproval[] = [];
  locationId: string | undefined;
  companyId: string | undefined;
  orderId: string | undefined;
  authToken: string = '';
  jobsData: GetDetailsResponse | undefined;
  mediaItems: FileLinkWithThumbnail[] | undefined;
  private swipeCooldown = false;
  isDeclineDisabled = false;
  isRequestCallbackDisabled = false;
  isAuthorizeDisabled = false;
  showDeclineButton = true;
  showAuthorizeButton = true;
  isAuthorized = false;
  totalPendingPrice: number | undefined;
  totalPendingJobsCount: number = 0;
  showFooter = false;
  private lastScrollTop = 0;
  introOutroMediaData!: DealerMediaResponse;
  isWalkthroughEnabled: boolean | undefined = false;
  dealerImageDisplay: boolean = false;
  currentWindowWidth: number = window.innerWidth;
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  walkthroughJob: any;
  jobStatus = JobStatus;
  Approvalstatus = Approvalstatus;

  @HostListener('swipeleft', ['$event'])
  onSwipeLeft(event: any) {
    if (this.selectedTabIndex < 3 && !this.swipeCooldown) {
      this.swipeCooldown = true;
      this.selectTab(this.selectedTabIndex + 1);
      setTimeout(() => (this.swipeCooldown = false), 300);
    }
  }

  @HostListener('swiperight', ['$event'])
  onSwipeRight(event: any) {
    if (this.selectedTabIndex > 0 && !this.swipeCooldown) {
      this.swipeCooldown = true;
      this.selectTab(this.selectedTabIndex - 1);
      setTimeout(() => (this.swipeCooldown = false), 300);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (window.innerWidth > 900) {
      if (scrollTop > this.lastScrollTop) {
        this.showFooter = true;
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.currentWindowWidth = (event.target as Window).innerWidth;
    this.hideDealerImage();
  }


  private hideDealerImage(): void {
    if (this.dealerImageDetails) {
      this.dealerImageDisplay = !this.dealerImageDetails.url && this.currentWindowWidth > 900;
    } else {
      this.dealerImageDisplay = this.currentWindowWidth > 900;
    }
  }

  constructor(public appService: AppService, private readonly route: ActivatedRoute, private readonly client: Client, public dialog: MatDialog, private snackBar: MatSnackBar) { }


  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['filter']) {
        this.selectedTab = params['filter'];
        this.selectedTabIndex = 3;
      }
      this.token = (params['token']);
    });
    this.loadChecklistData();
    if (window.innerWidth <= 900) {
      this.showFooter = true;
    }
  }

  get pendingTabLabel(): string {
    return `${this.pendingRequestsLabel} (${this.getPendingRequestsCount()})`;
  }

  priceTypeLabel(type: string | undefined): string {
    switch (type) {
      case 'Items':
        return this.partsLabel;
      case 'Labours':
        return this.labourLabel;
      case 'G/L Accounts':
        return this.glAccount;
      case 'Ex.Services':
        return this.ExServices;
      default:
        return type || '';
    }
  }

  loadChecklistData() {
    this.appService.responseData$.pipe(take(1)).subscribe((data) => {
      if (data) {
        this.apiResponse = data;
        this.details = this.apiResponse.healthCheckReportDetails;
        this.companyId = this.apiResponse?.companyId;
        this.orderId = this.details?.order?.id;
        this.locationId = this.details?.order?.locationId;
        this.authToken = this.apiResponse?.token;
        this.appService.getStyleSettings(this.token).pipe(take(1)).subscribe((settings) => {
          this.dealerImageDetails = settings?.dealerImage;
          this.hideDealerImage();
        });
        this.processChecklistData();
      } else {
        forkJoin({
          healthCheckReport: this.appService.getHealthCheckReportWithJobs(this.token).pipe(take(1)),
          siteSettings: this.appService.getStyleSettings(this.token).pipe(take(1)),
          dealerMedia: this.appService.getDealerMediaResponse(this.token).pipe(take(1))
        }).subscribe({
          next: ({ healthCheckReport, siteSettings, dealerMedia }) => {
            this.apiResponse = healthCheckReport;
            this.details = this.apiResponse.healthCheckReportDetails;
            this.companyId = this.apiResponse?.companyId;
            this.orderId = this.details?.order?.id;
            this.locationId = this.details?.order?.locationId;
            this.authToken = this.apiResponse?.token;
            this.dealerImageDetails = siteSettings?.dealerImage;
            this.hideDealerImage();
            this.introOutroMediaData = dealerMedia;
            this.processChecklistData();
          },
          error: (error) => {
            this.appService.handleErrorMessage(error);
          }
        });
      }
    });
  }

  private processChecklistData() {
    if (this.apiResponse) {
      this.details = this.apiResponse.healthCheckReportDetails;
      this.fetchCheckpointJobs();
      this.fetchFindingJobs();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['apiResponse']?.currentValue) {
      this.apiResponse = changes['apiResponse'].currentValue;
      this.companyId = this.apiResponse?.companyId;
      this.details = this.apiResponse?.healthCheckReportDetails;
      this.locationId = this.details?.order?.locationId;
      this.orderId = this.details?.order?.id;
      this.authToken = this.apiResponse?.token;
      this.appService.getStyleSettings(this.token).pipe(take(1)).subscribe((settings) => {
        this.dealerImageDetails = settings?.dealerImage;
        this.hideDealerImage();
      });
      this.processChecklistData();
    }
  }

  fetchCheckpointJobs() {
    if (!this.details?.categories) return;

    this.allCheckpointJobs = this.details.categories.flatMap((category: any) => {
      const { name: categoryName, checkpoints } = category;

      return checkpoints.map((checkpoint: any) => {
        const { findingTypeOptions, findings } = checkpoint;

        const findingColor =
          findingTypeOptions && findings?.length
            ? findingTypeOptions.find(
              (option: { id: any }) =>
                option.id === findings[0]?.findingType?.id
            )?.color || 'Unknown'
            : null;

        return {
          ...checkpoint,
          categoryName,
          findingColor,
          media: checkpoint.media?.map((mediaItem: any) => ({
            ...mediaItem,
            mimeType: mediaItem.mimeType.startsWith("image/")
              ? `Image/${mediaItem.mimeType.split("/")[1]}`
              : mediaItem.mimeType
          })),
        };
      });
    });

    this.checkpointJobs = [...this.allCheckpointJobs];

    if (this.selectedCategory !== "All") {
      this.checkpointJobs = this.checkpointJobs.filter(
        (job: any) => job.categoryName === this.selectedCategory
      );
    }
  }

  fetchFindingJobs() {
    if (!this.details?.categories) return;

    this.allFindingsJobs = this.details.categories
      .filter((category: { findingTypeOptions: any; }) => !category.findingTypeOptions)
      .flatMap(this.extractFindingsJobs.bind(this));

    this.allFindingsJobs = this.allFindingsJobs.map((job: any) => ({
      ...job,
      media: job.media?.map((mediaItem: any) => ({
        ...mediaItem,
        mimeType: mediaItem.mimeType.startsWith("image/")
          ? `Image/${mediaItem.mimeType.split("/")[1]}`
          : mediaItem.mimeType
      }))
    }));

    this.findingsJobs = [...this.allFindingsJobs];

    if (this.selectedCategory !== "All") {
      this.findingsJobs = this.findingsJobs.filter(
        (job: { categoryName: string }) => job.categoryName === this.selectedCategory
      );
    }

    this.applyFilter();
  }


  private extractFindingsJobs(category: any) {
    const { name: categoryName, checkpoints } = category;
    return checkpoints.flatMap((checkpoint: any) => this.extractCheckpointFindings(checkpoint, categoryName));
  }

  private extractCheckpointFindings(checkpoint: any, categoryName: string) {
    const { description: checkpointName, findings, findingTypeOptions, isWalkthroughEnabled } = checkpoint;
    return (findings || []).map((finding: any) => this.createFindingJob(finding, categoryName, checkpointName, findingTypeOptions, isWalkthroughEnabled));
  }

  private createFindingJob(finding: any, categoryName: string, checkpointName: string, findingTypeOptions: any, isWalkthroughEnabled: boolean) {
    return {
      ...finding,
      categoryName,
      checkpointName,
      isWalkthroughEnabled,
      findingColor: findingTypeOptions?.find((option: { id: any; }) => option?.id === finding?.findingType?.id)?.color || 'Unknown'
    };
  }

  applyFilter() {
    this.checkpointJobs = [...this.allCheckpointJobs];
    this.findingsJobs = [...this.allFindingsJobs];
    this.filteredFindingsJobs = [];

    if (this.selectedCategory !== 'All') {
      this.checkpointJobsCategoryWise = this.checkpointJobs.filter((job: any) => job.categoryName === this.selectedCategory);
      this.findingsJobsCategoryWise = this.findingsJobs.filter((job: any) => job.categoryName === this.selectedCategory);
    }
    else {
      this.checkpointJobsCategoryWise = this.checkpointJobs;
      this.findingsJobsCategoryWise = this.findingsJobs;
    }

    switch (this.selectedTab) {
      case 'critical':
        this.filteredFindingsJobs = this.findingsJobsCategoryWise.filter((job: any) => job.findingColor === 'Red');
        this.checkpointJobs = this.checkpointJobsCategoryWise.filter((job: any) => job.findingColor === 'Red');
        this.calculatePendingRequest();
        break;

      case 'caution':
        this.filteredFindingsJobs = this.findingsJobsCategoryWise.filter((job: any) => job.findingColor === 'Yellow');
        const notOkCheckpoints = this.checkpointJobsCategoryWise.filter((job: any) => job.status?.toLowerCase() === 'notok' && job.findingColor?.toLowerCase() !== 'red');
        const allFindings = this.allFindingsJobs;
        this.checkpointJobs = notOkCheckpoints.filter((checkpointJob: any) => {
          if (checkpointJob.serviceJobs?.length && checkpointJob.findingColor === 'Yellow') {
            return true;
          }
          return !allFindings.some((finding: any) =>
            checkpointJob.categoryName === finding.categoryName &&
            checkpointJob.description === finding.checkpointName
          );
        });
        this.calculatePendingRequest();
        break;

      case 'checked':
        this.checkpointJobs = this.checkpointJobsCategoryWise.filter((job: any) => job.status?.toLowerCase() === 'ok');
        this.filteredFindingsJobs = [];
        this.calculatePendingRequest();
        break;

      default:
        this.checkpointJobs = this.checkpointJobsCategoryWise.filter((job: any) =>
          job.serviceJobs?.some((sj: any) => {
            const status = sj.approvalStatus?.trim().toLowerCase() || '';
            return status === '' || status === 'notprovided';
          })
        );
        this.checkpointJobs.sort((a: any, b: any) =>
          (b.isWalkthroughEnabled ? 1 : 0) - (a.isWalkthroughEnabled ? 1 : 0)
        );

        this.filteredFindingsJobs = this.findingsJobsCategoryWise.filter((job: any) =>
          job.serviceJobs?.some((sj: any) => {
            const status = sj.approvalStatus?.trim().toLowerCase() || '';
            return status === '' || status === 'notprovided';
          })
        );
        this.filteredFindingsJobs.sort((a: any, b: any) =>
          (b.isWalkthroughEnabled ? 1 : 0) - (a.isWalkthroughEnabled ? 1 : 0)
        );

        this.calculatePendingRequestAndUpdatePriceTotal();
        break;
    }

    const walkthroughJobFromCheckpoint = this.checkpointJobs.find((job: any) => job.isWalkthroughEnabled);
    const walkthroughJobFromFindings = this.filteredFindingsJobs.find((job: any) => job.isWalkthroughEnabled);
    this.walkthroughJob = walkthroughJobFromCheckpoint || walkthroughJobFromFindings;

    if (this.walkthroughJob) {
      this.checkpointJobs = this.checkpointJobs.filter((job: any) => job !== this.walkthroughJob);
      this.filteredFindingsJobs = this.filteredFindingsJobs.filter((job: any) => job !== this.walkthroughJob);
    }

    this.mediaItems = this.filteredFindingsJobs.flatMap((job: any) => job.Media || []);

  }


  calculateGrossTotal(priceSummary: number[]): number {
    const total = priceSummary.reduce((sum, price) => sum + price, 0);
    const roundedTotal = parseFloat(total.toFixed(2));
    return roundedTotal;
  }

  calculatePendingRequestAndUpdatePriceTotal() {
    const cpJobs = this.checkpointJobsCategoryWise.filter(
      (job: any) => job.serviceJobs?.some((sj: any) => {
        const status = sj.approvalStatus?.trim().toLowerCase() || '';
        return status === '' || status === 'notprovided';
      })
    );
    const fdJobs = this.findingsJobsCategoryWise.filter(
      (job: any) => job.serviceJobs?.some((sj: any) => {
        const status = sj.approvalStatus?.trim().toLowerCase() || '';
        return status === '' || status === 'notprovided';
      })
    );

    const pendingJobs = [...cpJobs, ...fdJobs];
    this.totalPendingJobsCount = pendingJobs.length;

    const pendingPrices = pendingJobs.flatMap((job: any) =>
      job.serviceJobs?.flatMap((servicejob: any) =>
        servicejob.priceSummary?.map((pricesummary: any) => pricesummary?.price?.grossPrice || 0) || []
      ) || []
    );
    this.totalPendingPrice = this.calculateGrossTotal(pendingPrices);
  }

  calculatePendingRequest() {
    const cpJobs = this.checkpointJobsCategoryWise.filter(
      (job: any) => job.serviceJobs?.some((sj: any) => {
        const status = sj.approvalStatus?.trim().toLowerCase() || '';
        return status === '' || status === 'notprovided';
      })
    );
    const fdJobs = this.findingsJobsCategoryWise.filter(
      (job: any) => job.serviceJobs?.some((sj: any) => {
        const status = sj.approvalStatus?.trim().toLowerCase() || '';
        return status === '' || status === 'notprovided';
      })
    );

    const pendingJobs = [...cpJobs, ...fdJobs];
    this.totalPendingJobsCount = pendingJobs.length;
  }

  selectTab(index: number) {
    const tabMap = ['pending', 'critical', 'caution', 'checked'];
    this.selectedTab = tabMap[index];
    this.selectedTabIndex = index;
    this.applyFilter();
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.fetchCheckpointJobs();
    this.fetchFindingJobs();
  }

  onButtonGroupClick(buttonName: string, job: any) {
    let context = "VHC";
    let condition = 'pending';
    if (job.findingColor === 'Red') {
      condition = 'critical';
    } else if (job.findingColor === 'Yellow') {
      condition = 'caution';
    } else if (job.status?.toLowerCase() === 'ok') {
      condition = 'checked';
    }
    if (buttonName === Approvalstatus.Accept) {
      this.approveOrDeclineCall(buttonName, job)
    }
    else {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          context: context,
          checkpoint: job.checkpointName,
          finding: job.description,
          serviceJob: job.solution?.description,
          condition: condition,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.approveOrDeclineCall(buttonName, job)
        }
      });
    }

  }

  approveOrDeclineCall(buttonName: string, job: any) {
    const ServiceJobs = job?.serviceJobs ?? [];

    this.bodyData = ServiceJobs.map((x: any) => <EndApproval>{
      id: String(x.id),
      description: x.description,
      descriptionLong: x.descritpionLong,
      price: x.price,
      approvalStatus: buttonName,
      billToClientName: x.billToCustomerName
    })

    const locationId = this.locationId?.replace(/[{ }]/g, '');

    this.client.consentDetails(this.authToken, this.companyId, this.orderId, locationId, this.bodyData).subscribe((response: any) => {
      for (const serviceJob of this.checkpointJobs || this.findingsJobs) {
        if (serviceJob.id === job.id) {
          serviceJob.serviceJobs[0].approvalStatus = buttonName;
        }
      }

      if (response.status === 200 && buttonName) {
        job.serviceJobs[0].approvalStatus = buttonName;
        if (buttonName === 'Accept') {
          this.showAuthorizationMessage();
        }
        this.loadChecklistData();
        this.updateChecklistData.emit();
      }
    });
  }


  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  onApproveAllOrDeclineAllClick(buttonName: string) {
    const isDisabled =
      (buttonName === Approvalstatus.Accept && (this.isAuthorizeDisabled || (this.totalPendingJobsCount ?? 0) <= 1)) ||
      (buttonName === Approvalstatus.Reject && (this.isDeclineDisabled || (this.totalPendingJobsCount ?? 0) <= 1));

    if (isDisabled) {
      return;
    }

    const allJobs: any[] = [];
    if (Array.isArray(this.checkpointJobs)) {
      allJobs.push(...this.checkpointJobs);
    }
    if (Array.isArray(this.findingsJobs)) {
      allJobs.push(...this.findingsJobs);
    }

    const serviceJobs = allJobs.flatMap((job: any) => job?.serviceJobs ?? []);
    const arrayOfMatchedData: any[] = serviceJobs.filter((item: any | undefined) =>
      item && item.approvalStatus !== 'Accept' && item.approvalStatus !== 'Reject');
    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: buttonName + 'Disclaimer',
        jobs: (arrayOfMatchedData.length == this.serviceJobs.length) ? 'all' : arrayOfMatchedData.length,
        cost: this.totalPendingPrice
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.approveOrDeclineAllCall(buttonName)
      }
    });
  }


  approveOrDeclineAllCall(buttonName: string) {
    const allJobs: any[] = [];
    if (Array.isArray(this.checkpointJobs)) {
      allJobs.push(...this.checkpointJobs);
    }
    if (Array.isArray(this.findingsJobs)) {
      allJobs.push(...this.findingsJobs);
    }

    const serviceJobs = allJobs.flatMap((job: any) => job?.serviceJobs ?? []);
    const arrayOfMatchedData: any[] = serviceJobs.filter((item: any | undefined) =>
      item && item.approvalStatus !== 'Accept' && item.approvalStatus !== 'Reject');

    this.bodyData = arrayOfMatchedData.map((serviceJob: any) => <EndApproval>{
      id: String(serviceJob.id),
      description: serviceJob.description,
      descriptionLong: serviceJob.descritpionLong,
      price: serviceJob.price,
      approvalStatus: buttonName,
      billToClientName: serviceJob.billToCustomerName
    });

    const locationId = this.locationId?.replace(/[{ }]/g, '');

    this.client.consentDetails(this.authToken, this.companyId, this.orderId, locationId, this.bodyData).subscribe({
      next: () => {
        arrayOfMatchedData.forEach(serviceJob => {
          serviceJob.approvalStatus = buttonName;
        });
        this.updateButtonStates(buttonName);
        this.loadChecklistData();
        this.updateChecklistData.emit();
      },
      error: (error) => {
        this.appService.handleErrorMessage(error);
      }
    });
  }

  updateButtonStates(buttonName: string) {
    if (buttonName === Approvalstatus.Accept) {
      this.isAuthorizeDisabled = true;
      this.isDeclineDisabled = true;
      this.isRequestCallbackDisabled = true;
    } else if (buttonName === Approvalstatus.Reject) {
      this.isDeclineDisabled = true;
      this.isAuthorizeDisabled = true;
      this.isRequestCallbackDisabled = true;
    } else if (buttonName === Approvalstatus.NotProvided) {
      this.isRequestCallbackDisabled = false;
      this.isAuthorizeDisabled = false;
      this.isDeclineDisabled = false;
    }
  }


  getNoJobsMessage(): { title: string; description: string } {
    const target = this.selectedCategory === 'All' ? 'vehicle' : this.selectedCategory.toLowerCase();
    switch (this.selectedTab) {
      case 'pending':
        return {
          title: this.noPendingRequest,
          description: $localize`There are no pending requests for your ${target}.`
        };
      case 'critical':
        return {
          title: this.noCriticalFindings,
          description: $localize`There are no critical findings in your ${target}.`
        };
      case 'caution':
        return {
          title: this.noCautionaryFindings,
          description: $localize`There are no cautionary findings in your ${target}.`
        };
      case 'checked':
        return {
          title: this.noCheckedFindings,
          description: $localize`There are no checked and ok findings in your ${target}.`
        };
      default:
        return {
          title: this.noFindingsAvailable,
          description: $localize`There are no findings recorded for your ${target} at the moment.`
        };
    }
  }


  getPendingRequestsCount(): number {
    return (this.totalPendingJobsCount);
  }
  onKeyPress(event: KeyboardEvent, category: string) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.selectCategory(category);
    }
  }

  getTotalGrossPrice(priceSummary: any[]): number {
    if (!priceSummary || !Array.isArray(priceSummary)) return 0;
    return priceSummary.reduce((total, item) => total + ((item?.price?.grossPrice || item?.grossPrice) || 0), 0).toFixed(2);
  }

  getTotalDiscount(priceSummary: any[]): number {
    if (!priceSummary || !Array.isArray(priceSummary)) return 0;
    return Number(priceSummary.reduce((total, item) => total + ((item?.price?.discount?.amount || item?.discount?.amount) || 0), 0).toFixed(2));
  }


  showAuthorizationMessage(): void {
    this.snackBar.openFromComponent(TickSnackbarComponent, {
      data: this.authorizationSent,
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar']
    });
  }

  getBadgeClass(job: any): string {
    const status = job?.status?.toLowerCase();
    const color = job?.findingColor?.toLowerCase();

    if (status === 'ok') {
      return 'green-badge';
    }

    if (status === 'notok') {
      if (color === 'red') return 'red-badge';
      if (color === 'yellow') return 'yellow-badge';
    }

    return 'yellow-badge';
  }

  getBadgeLabel(job: any): string {
    const status = job?.status?.toLowerCase();
    const color = job?.findingColor?.toLowerCase();

    if (status === 'ok') return 'Checked and OK';
    if (status === 'notok' && color === 'red') return 'Critical';
    if (status === 'notok' && color === 'yellow') return 'Caution';

    return 'Caution';
  }
  
  getCurrency(priceSummary: any[]): string {
    if (!priceSummary || !Array.isArray(priceSummary) || priceSummary.length === 0) {
      return 'USD';
    }
    
    const priceWithCurrency = priceSummary.find(item => item?.currency || item?.price?.currency);
    return priceWithCurrency?.currency || priceWithCurrency?.price?.currency || 'USD';
  }
}
